import { METER_SCOPE_NAMES } from 'common/src/database/scopes/meters/meterScopeNames';
import { DataQueryParams } from 'common/src/query-params/DataQueryParams';
import { IMeter, IPage } from 'common/src/types/interfaces';
import {
  ICreateMeterDto,
  IMeterListScopes,
  IUpdateMeterDto,
  MeterListScopeName,
} from 'common/src/types/meter.dtos';

import { API_BASE_PATHS } from 'portal/src/api/constants';
import formatQueryParams from 'portal/src/api/formatQueryParams';
import {
  deleteRequest,
  getRequest,
  patchRequest,
  postRequest,
} from 'portal/src/api/requestTypes';

/**
 * Returns a page of meters shaped by the requested list scope
 * (defaults to the API's `minimal` scope).
 */
export const getMeters = async <
  Scope extends MeterListScopeName = typeof METER_SCOPE_NAMES.minimal,
>(
  params: DataQueryParams & { scope?: Scope } = {},
): Promise<IPage<IMeterListScopes[Scope]>> => {
  return await getRequest(API_BASE_PATHS.METERS, formatQueryParams(params));
};

export const getMeter = async (id: string): Promise<IMeter> =>
  await getRequest(`${API_BASE_PATHS.METERS}/${id}`);

export const addMeter = async (body: ICreateMeterDto): Promise<string> =>
  await postRequest(API_BASE_PATHS.METERS, {}, body);

export const updateMeter = async (
  id: string,
  body: IUpdateMeterDto,
): Promise<void> =>
  await patchRequest(`${API_BASE_PATHS.METERS}/${id}`, {}, body);

export const deleteMeter = async (id: string): Promise<void> =>
  await deleteRequest(`${API_BASE_PATHS.METERS}/${id}`, {});
